class GridPreRowController {
    constructor($transclude) {
        this.transclude = $transclude;
    }

    $onInit() {
        this.grid.addPreRow(this);
    }
}

GridPreRowController.$inject = ['$transclude'];

const gridPreRowDirective = {
    restrict: 'E',
    scope: true,
    controller: GridPreRowController,
    controllerAs: 'gridPreRowCtrl',
    bindToController: {},
    transclude: true,
    require: {
        grid: '^ctxGrid'
    }
};

module.exports = function () {
    return gridPreRowDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridPreRow.directive.js